import { useState } from 'react';
import { api, ApiError } from '../api';

export function AccessGate({ onGranted }: { onGranted: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event?: React.FormEvent) => {
    event?.preventDefault();
    if (busy || password.length === 0) return;
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onGranted();
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : 'Anmeldung fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="gate panel">
      <h2>Geschützte Demo</h2>
      <form onSubmit={submit}>
        <label htmlFor="demo-password">Zugangscode</label>
        <input
          id="demo-password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              void submit();
            }
          }}
          required
        />
        {error && (
          <p className="notice error" role="alert">
            {error}
          </p>
        )}
        <button className="btn" type="submit" disabled={busy || password.length === 0}>
          {busy ? 'Prüfe …' : 'Demo öffnen'}
        </button>
      </form>
    </div>
  );
}
